import { Component } from '@angular/core';

@Component({
  selector: 'app-longgoldbar',
  templateUrl: './longgoldbar.component.html',
  styleUrls: ['./longgoldbar.component.css']
})
export class LonggoldbarComponent {

}
